export const paymentMethodStatus = [{
  value: 'Undefined', label: 'Undefined', color: 'gray'
}, {
  value: 'Active', label: 'Active', color: 'green'
}, {
  value: 'Deleted', label: 'Deleted', color: 'red'
}];